import _ from 'lodash'
import React, { useEffect } from 'react'
import ProductFilterDesktopModal from './ProductFilterDesktopModal/ProductFilterDesktopModal'
import ProductFilterMobileModal from './ProductFilterMobileModal/ProductFilterMobileModal'
import useMatchMedia from '../../../hooks/matchMedia/matchMedia'
import { ActiveFiltersInterface, ProductFiltersInterface } from '../../../interfaces/FiltersInterface'

interface Props {
  filters: ProductFiltersInterface
  activeFilters: ActiveFiltersInterface
  open: boolean
  loading: boolean
  itemsCounter: number
  onFlatAttributeChange: (name: string, valueId: number | string, checked: boolean) => void
  onAttributeChange: (attributeId: number, valueId: number, checked: boolean) => void
  onRangeChanged: (attributeId: string, minValue: string | null, maxValue: string | null, extra?: object) => void
  clearFilters: () => void
  onClose: () => void
}

const ProductFilterModal: React.FC<Props> = (props: Props) => {
  const { isDesktop } = useMatchMedia()
  useEffect(() => {
    if (props.open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [props.open])

  return isDesktop ? (
    <ProductFilterDesktopModal
      open={props.open}
      onClose={props.onClose}
      filters={props.filters}
      activeFilters={props.activeFilters}
      onFlatAttributeChange={props.onFlatAttributeChange}
      onAttributeChange={props.onAttributeChange}
      onRangeChanged={props.onRangeChanged}
      clearFilters={props.clearFilters}
    />
  ) : (
    <ProductFilterMobileModal
      open={props.open}
      onClose={props.onClose}
      filters={props.filters}
      activeFilters={props.activeFilters}
      loading={props.loading}
      itemsCounter={props.itemsCounter}
      onFlatAttributeChange={props.onFlatAttributeChange}
      onAttributeChange={props.onAttributeChange}
      onRangeChanged={props.onRangeChanged}
      clearFilters={props.clearFilters}
    />
  )
}

export default ProductFilterModal
